import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "onboarding"
    }}>{`Onboarding`}</h1>
    <p>{`These are guidelines and best practices on how to guide your users as they interact with your plugin. Providing users with examples on how to use the plugin can help your user get the most out of the plugin. This is helpful when the user is interacting with the plugin for the first time.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/cfceb831f54ed4e17a82bacc6ebb0e08/5530d/Onboarding-BP.webp 320w", "/photoshop/uxp/2022/static/cfceb831f54ed4e17a82bacc6ebb0e08/0c8fb/Onboarding-BP.webp 640w", "/photoshop/uxp/2022/static/cfceb831f54ed4e17a82bacc6ebb0e08/94b1e/Onboarding-BP.webp 1280w", "/photoshop/uxp/2022/static/cfceb831f54ed4e17a82bacc6ebb0e08/0b34d/Onboarding-BP.webp 1920w", "/photoshop/uxp/2022/static/cfceb831f54ed4e17a82bacc6ebb0e08/9acb0/Onboarding-BP.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/cfceb831f54ed4e17a82bacc6ebb0e08/dd4a7/Onboarding-BP.png 320w", "/photoshop/uxp/2022/static/cfceb831f54ed4e17a82bacc6ebb0e08/0f09e/Onboarding-BP.png 640w", "/photoshop/uxp/2022/static/cfceb831f54ed4e17a82bacc6ebb0e08/bbbf7/Onboarding-BP.png 1280w", "/photoshop/uxp/2022/static/cfceb831f54ed4e17a82bacc6ebb0e08/ac7a9/Onboarding-BP.png 1920w", "/photoshop/uxp/2022/static/cfceb831f54ed4e17a82bacc6ebb0e08/369c0/Onboarding-BP.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/cfceb831f54ed4e17a82bacc6ebb0e08/bbbf7/Onboarding-BP.png",
            "alt": "Onboarding modal example",
            "title": "Onboarding modal example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "best-practices"
    }}>{`Best practices`}</h2>
    <h4 {...{
      "id": "content"
    }}><strong parentName="h4">{`Content`}</strong></h4>
    <p>{`Provide examples or tutorials on how to use your plugin, this can be done by using visual or gifs.`}</p>
    <p><strong parentName="p">{`A. Plugin interaction`}</strong><br parentName="p"></br>{`
`}{`Highlight key interactions to make sure users can get the plugin to work.`}</p>
    <p><strong parentName="p">{`B. Login experience`}</strong><br parentName="p"></br>{`
`}{`If the user needs to log in or sign up for a service to use your plugin, guide them through the sign-up process.`}</p>
    <p><strong parentName="p">{`C. Authentication`}</strong><br parentName="p"></br>{`
`}{`If the plugin needs an API key or other account information, provide clear instructions on how they can get that information or provide a link.`}</p>
    <p><strong parentName="p">{`D. Help`}</strong><br parentName="p"></br>{`
`}{`Provide access to an external help link or help documentation in the main navigation of your plugin or in error modal dialogs to allow a user to troubleshoot.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      